import API from './api';
import { exportResults } from '../utils';
import { HTTP } from '../config/http-common';
import { ROUTE_API } from '../constants/routes';

export default class Folder extends API {
    getListParent = async (id) => exportResults(await HTTP.get(`${ROUTE_API.FOLDER_PARENT}/${id}`));
}
